import { Link } from 'react-router'
import { ArrowLeft, Sparkles, Brain, Calculator, Users, Image, FileText, TrendingUp, Shield } from 'lucide-react'
import { Button } from '#app/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '#app/components/ui/card'

export default function FeaturesPage() {
  const features = [
    {
      icon: Brain,
      title: 'AI Assistent',
      description: 'Krijg gepersonaliseerde aanbevelingen op basis van je woonsituatie en wensen.',
      link: '/ai-assistant'
    },
    {
      icon: Calculator,
      title: 'ROI Calculator',
      description: 'Bereken het rendement van je renovatie-investeringen met actuele marktdata.',
      link: '/roi-calculator'
    },
    {
      icon: TrendingUp,
      title: 'Energietracker',
      description: 'Monitor je energieverbruik en ontdek besparingsmogelijkheden tot €2.150 per jaar.',
      link: '/energy'
    },
    {
      icon: Users,
      title: 'Professional Matching',
      description: 'Vind betrouwbare vakmensen voor jouw renovatieproject.',
      link: '/marketplace'
    },
    {
      icon: Image,
      title: 'Plattegrond Bouwer',
      description: 'Teken je huidige en gewenste plattegrond met onze intuïtieve tool.',
      link: '/projects/floorplans'
    },
    {
      icon: Sparkles,
      title: 'Moodboards',
      description: 'Verzamel inspiratie en deel je visie met het team.',
      link: '/projects/moodboards'
    },
    {
      icon: FileText,
      title: 'Documenten Beheer',
      description: 'Bewaar al je offertes, vergunningen en contracten op één plek.',
      link: '/projects/documents'
    },
    {
      icon: Shield,
      title: 'Veilige Opslag',
      description: 'Je gegevens zijn veilig met enterprise-grade beveiliging.',
      link: '/security'
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/50">
      <div className="container mx-auto px-4 py-16 max-w-6xl">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Terug naar home
        </Link>

        <div className="space-y-12">
          <div className="text-center space-y-4">
            <Sparkles className="h-16 w-16 mx-auto text-primary" />
            <h1 className="text-4xl font-bold">Alle Features</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Ontdek alle tools die Woonplan biedt om je renovatieproject tot een succes te maken
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <Card key={index} className="hover:shadow-lg transition-shadow">
                  <CardHeader>
                    <Icon className="h-10 w-10 text-primary mb-2" />
                    <CardTitle>{feature.title}</CardTitle>
                    <CardDescription>{feature.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Button variant="ghost" className="w-full" asChild>
                      <Link to={feature.link}>
                        Meer informatie <ArrowLeft className="ml-2 h-4 w-4 rotate-180" />
                      </Link>
                    </Button>
                  </CardContent>
                </Card>
              )
            })}
          </div>

          <div className="bg-primary/5 rounded-lg p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Klaar om te beginnen?</h2>
            <p className="text-muted-foreground mb-6">
              Start vandaag nog met het plannen van je droomrenovatie
            </p>
            <Button size="lg" asChild>
              <Link to="/start">Start Gratis</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}